import ApiService from "@/core/services/ApiService";

class CertificateService {

    public static getSearch(data: any) {
        return ApiService.post('public/certificate', data)
    }
}

export default CertificateService;